import graphql__9c14d353fc06abac68f2 from "./__generated__/ProjectHeader_project.graphql.ts";import * as React from "react";
import {createFragmentContainer, graphql} from "react-relay";
import {ProjectBillingMode, ProjectHeader_project$data} from "./__generated__/ProjectHeader_project.graphql";
import StatusBadge from "./presentational/StatusBadge";
import {ProjectState} from "./dialog/__generated__/ArchiveProjectDialogMutation.graphql";
import {useIntl} from "react-intl";

type ProjectHeaderProps = {
    project: ProjectHeader_project$data,
};

const ProjectHeader: React.FC<ProjectHeaderProps> = ({project}) => {
    const intl = useIntl();

    const getBillingModeLabel = (billingMode: ProjectBillingMode): string => {
        switch (billingMode) {
            case 'TIME_AND_MATERIALS':
                return intl.formatMessage({id: 'header.project.billingMode.timeAndMaterials'});
            case 'FIXED_FEE':
                return intl.formatMessage({id: 'header.project.billingMode.fixedFee'});
            default:
                return intl.formatMessage({id: 'header.project.billingMode.nonBillable'});
        }
    }

    const getStateLabel = (state: ProjectState): string => {
        switch (state) {
            case 'ARCHIVED':
                return intl.formatMessage({id: 'header.project.state.archived'});
            default:
                return intl.formatMessage({id: 'header.project.state.active'});
        }
    }
    return (
        <div className="mt-6 mx-auto px-4 sm:px-6 lg:px-8">
            <div className="ml-4 mt-4 flex flex-wrap items-center justify-between">
                <div className="ml-4 flex items-center">
                    <div>
                        <h2 className="text-xl font-medium text-gray-700">{project.customerAccount.customerName}</h2>
                        <h1 className="text-2xl font-bold text-gray-900">
                            {project.projectName}
                            <StatusBadge
                                value={project.state}
                                states={{gray: ['ARCHIVED'], green: ['ACTIVE']}}
                                label={getStateLabel(project.state)}
                                size="base"
                                className="mx-2 ml-4"
                            />
                            <StatusBadge
                                value={project.billingMode}
                                states={{gray: ['NON_BILLABLE'], green: ['TIME_AND_MATERIALS', 'FIXED_FEE']}}
                                label={getBillingModeLabel(project.billingMode)}
                                size="base"
                                className="mx-2"
                            />
                        </h1>
                        <p className="text-sm font-medium text-gray-500">{project.id}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default createFragmentContainer(ProjectHeader, {
        project: graphql__9c14d353fc06abac68f2
    }
);
